module.exports = __webpack_public_path__ + "static/media/calendar-check-yellow.008b6643.svg";